/**
 *  covariance divided by the variance
 */

export function calcBeta(covariance: number, variance: number) {
  return covariance / variance
}
